import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-summary',
  templateUrl: './summary.component.html',
  styleUrls: ['./summary.component.css']
})
export class SummaryComponent {
  @Input() total: any;
  message: string = "Hola Mundo!";
  messageSummary: string = "Esto es un mensaje Desde el Resumen";
  
  @Output() messageEvent = new EventEmitter<string>();
  @Output() seccondEvent = new EventEmitter<string>();
  // @Input() total: string | null = null;

  constructor() { }

  sendMessage() {
    this.messageEvent.emit(this.message);
  }

  sendSecondAction() {
    this.seccondEvent.emit("otro valor porceaca");
  }
}
